/**
 * Catalogo de los tipos de plano + sus paletas de iconos/herramientas.
 * Los iconos viven en frontend/public/iconos-planos/{categoria}/{nombre}.png
 *
 * Cada paleta define los items que aparecen en el sidebar derecho del editor.
 * Cada item puede ser:
 *   - tipo 'icon' (imagen PNG/SVG)
 *   - tipo 'shape' (forma generada: linea, rectangulo, etc)
 *   - tipo 'text' (caja de texto)
 *
 * Las NOTAS y la herramienta de TEXTO son comunes a todos los tipos, se
 * agregan automaticamente en el editor (no en el catalogo).
 */

// multihoja: admite varias hojas (+ Hoja). miniMapa: el plano base sale pequeño
// arriba a la derecha (la "lupa") y el resto del lienzo queda libre.
// Los "Detalle ..." funcionan igual que el Plano de Detalle.
// El orden de esta lista es el orden de los planos en el editor, en Planos
// Generados, en la Ficha FFE y en el PDF (vps-api/src/routes/upload.js).
const DETALLE = { descripcion: 'Recuadros rojos para señalar zonas', multihoja: true, miniMapa: true };

export const TIPOS_PLANO = [
  { id: 'existente',          nombre: 'Plano Existente',           descripcion: 'Solo notas sobre el plano base' },
  { id: 'demoliciones',       nombre: 'Plano Demoliciones',        descripcion: 'Trazos de muros a demoler' },
  { id: 'muros_nuevos',       nombre: 'Plano Muros Nuevos',        descripcion: 'Trazos de muros nuevos' },
  { id: 'electrico',          nombre: 'Plano Eléctrico',           descripcion: 'Tomas, switches, salidas TV, GFCI' },
  { id: 'iluminacion',        nombre: 'Plano Iluminación',         descripcion: 'Lámparas, paneles LED, luz indirecta' },
  { id: 'cielos',             nombre: 'Plano Cielos',              descripcion: 'Cortineros, cielos en drywall' },
  { id: 'texturas',           nombre: 'Plano Texturas en Muro',    descripcion: 'Microcemento, piedra, pintura' },
  { id: 'pisos_enchapes',     nombre: 'Plano de Pisos y Enchapes', descripcion: 'Zonas de piso y de enchape' },
  { id: 'puertas',            nombre: 'Plano de Puertas',          descripcion: 'Corredizas, batientes, cantidades y ubicaciones' },
  { id: 'detalle',            nombre: 'Plano de Detalle',          ...DETALLE },
  { id: 'detalle_cocina',     nombre: 'Detalle Cocina',            ...DETALLE },
  { id: 'detalle_isla',       nombre: 'Detalle Isla',              ...DETALLE },
  { id: 'detalle_puertas',    nombre: 'Detalle Puertas',           ...DETALLE },
  { id: 'detalle_bano',       nombre: 'Detalle Baño',              ...DETALLE },
  { id: 'detalle_closet',     nombre: 'Detalle Closet',            ...DETALLE },
  { id: 'detalle_vestier',    nombre: 'Detalle Vestier',           ...DETALLE },
  { id: 'detalle_zona_ropas', nombre: 'Detalle Zona de Ropas',     ...DETALLE },
  { id: 'imagenes_3d',        nombre: 'Imágenes 3D',               descripcion: 'Renders del proyecto', multihoja: true, miniMapa: true },
  { id: 'notas_especiales',   nombre: 'Notas Especiales',          descripcion: 'Fotos con notas' },
];

// Catalogos de iconos por tipo. Cada entrada genera un thumb arrastrable.
export const PALETAS = {
  electrico: [
    { id: 'toma_nuevo',         label: 'Toma nuevo',         src: '/iconos-planos/ELECTRICO/TOMA NUEVO.png',         w: 40 },
    { id: 'toma_gfci',          label: 'Toma GFCI',          src: '/iconos-planos/ELECTRICO/TOMA NUEVO GFCI.png',    w: 40 },
    { id: 'traslado_toma',      label: 'Traslado de toma',   src: '/iconos-planos/ELECTRICO/TRASLADO DE TOMA.png',   w: 40 },
    { id: 'switche_nuevo',      label: 'Switche nuevo',      src: '/iconos-planos/ELECTRICO/SWITCHE NUEVO.png',      w: 40 },
    { id: 'translado_switche',  label: 'Traslado switche',   src: '/iconos-planos/ELECTRICO/TRANSLADO SWITCHE.png',  w: 40 },
    { id: 'salida_tv',          label: 'Salida de TV',       src: '/iconos-planos/ELECTRICO/SALIDA DE TV.png',       w: 40 },
  ],
  iluminacion: [
    { id: 'lampara_colgar',     label: 'Lámpara nueva',          src: '/iconos-planos/ILUMINACION/LAMPARA DE COLGAR NUEVA.png', w: 40 },
    { id: 'panel_led',          label: 'Ojo de buey nuevo',      src: '/iconos-planos/ILUMINACION/PANEL LEDD.png',              w: 36 },
    { id: 'luz_indirecta',      label: 'Iluminación indirecta',  src: '/iconos-planos/ILUMINACION/LUZ INDIRECTA.png',           w: 40 },
    { id: 'traslado_iluminacion', label: 'Traslado iluminación', src: '/iconos-planos/ILUMINACION/TRASLADO ILUMINACION.svg',    w: 40 },
  ],
  // Para tipos que no son iconos sino trazos/shapes
  demoliciones: [
    { id: 'muro_demoler', label: 'Muro a demoler', shape: 'line', stroke: '#dc2626', strokeWidth: 6 },
  ],
  muros_nuevos: [
    { id: 'muro_nuevo', label: 'Muro nuevo', shape: 'line', stroke: '#eab308', strokeWidth: 6 },
  ],
  cielos: [
    { id: 'cortinero', label: 'Cortinero', shape: 'rect_border', stroke: '#7c3aed', strokeWidth: 3, fill: 'rgba(124,58,237,0.22)' },
    { id: 'cielo_drywall', label: 'Cielo drywall', shape: 'rect_border', stroke: '#0891b2', strokeWidth: 3, fill: 'rgba(8,145,178,0.22)' },
  ],
  texturas: [
    { id: 'microcemento', label: 'Microcemento', shape: 'rect_fill', fill: 'rgba(156,163,175,0.4)', stroke: '#6b7280', strokeWidth: 2 },
    { id: 'piedra',        label: 'Piedra',        shape: 'rect_fill', fill: 'rgba(180,83,9,0.35)',   stroke: '#92400e', strokeWidth: 2 },
    { id: 'pintura_color', label: 'Pintura color', shape: 'rect_fill', fill: 'rgba(59,130,246,0.3)',  stroke: '#1d4ed8', strokeWidth: 2 },
  ],
  puertas: [
    { id: 'puerta_p1', label: 'P1 · Puerta batiente',    src: '/iconos-planos/PUERTAS/P1.svg', w: 38 },
    { id: 'puerta_p2', label: 'P2 · Puerta corrediza',   src: '/iconos-planos/PUERTAS/P2.svg', w: 38 },
    { id: 'puerta_p3', label: 'P3 · Puerta en vidrio',   src: '/iconos-planos/PUERTAS/P3.svg', w: 38 },
    { id: 'puerta_p4', label: 'P4 · Puerta especial',    src: '/iconos-planos/PUERTAS/P4.svg', w: 38 },
    { id: 'puerta_p5', label: 'P5 · Puerta en acordeón', src: '/iconos-planos/PUERTAS/P5.svg', w: 38 },
  ],
  pisos_enchapes: [
    { id: 'zona_piso',    label: 'Zona de piso',    shape: 'rect_fill', fill: 'rgba(22,163,74,0.28)',  stroke: '#15803d', strokeWidth: 2 },
    { id: 'zona_enchape', label: 'Zona de enchape', shape: 'rect_fill', fill: 'rgba(234,88,12,0.28)',  stroke: '#c2410c', strokeWidth: 2 },
  ],
  detalle: [
    { id: 'recuadro_rojo', label: 'Recuadro rojo', shape: 'rect_border', stroke: '#dc2626', strokeWidth: 4, fill: 'rgba(220,38,38,0.22)' },
  ],
  // Existente, imagenes_3d, notas_especiales: solo notas (comunes)
  existente: [],
  imagenes_3d: [],
  notas_especiales: [],
};
// Los "Detalle ..." usan las mismas herramientas del Plano de Detalle
TIPOS_PLANO.filter(t => t.id.startsWith('detalle_')).forEach(t => { PALETAS[t.id] = PALETAS.detalle; });

export const getTipoPlano = (id) => TIPOS_PLANO.find(t => t.id === id);

// Posición del tipo en el catálogo, para ordenar los planos igual en todas partes
export const ordenTipoPlano = (id) => {
  const i = TIPOS_PLANO.findIndex(t => t.id === id);
  return i === -1 ? TIPOS_PLANO.length : i;
};
